export default {
  async: {
    LOGIN: 'login',
    POST_CREATE_BENEFICIARY: 'postCreateBeneficiary',
    DATA_BENEFICIARY: 'getDataBeneficiary',
    POST_RECOVERY_PASSWORD: 'postRecoveryPassword',
    GET_VALIDATE_BENEFICIARY: 'getValidateBeneficiary',
    GET_VERIFY_BENEFICIARY: 'verifyBeneficiary',
    GET_VERIFY_CI: 'getVerifyCI',
    GET_VERIFY_BENEFICIARY_SEND_EMAIL: 'getVerifyBeneficiarySendEmail',
  },
  actions: {
    SAVE_USER: 'saveUser',
    SAVE_TOKEN: 'saveToken',
    DATA_BENEFICIARY: 'getDataBeneficiary',
    POST_CREATE_BENEFICIARY: 'postCreateBeneficiary',
    POST_RECOVERY_PASSWORD: 'postRecoveryPassword',
    GET_VALIDATE_BENEFICIARY: 'getValidateBeneficiary',
    REMOVE_ALL: 'removeAll',
    GET_VERIFY_BENEFICIARY: 'getVerifyBeneficiary',
    GET_VERIFY_CI: 'getVerifyCI',
    GET_VERIFY_BENEFICIARY_SEND_EMAIL: 'getVerifyBeneficiarySendEmail',
  },
  mutations: {
    SAVE_USER: 'saveUser',
    SAVE_TOKEN: 'saveToken',
    DATA_BENEFICIARY: 'getDataBeneficiary',
    POST_CREATE_BENEFICIARY: 'postCreateBeneficiary',
    POST_RECOVERY_PASSWORD: 'postRecoveryPassword',
    GET_VALIDATE_BENEFICIARY: 'getValidateBeneficiary',
    REMOVE_ALL: 'removeAll',
    GET_VERIFY_BENEFICIARY: 'getVerifyBeneficiary',
    GET_VERIFY_CI: 'getVerifyCI',
    GET_VERIFY_BENEFICIARY_SEND_EMAIL: 'getVerifyBeneficiarySendEmail',
  },
};
